import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Header from "./layout/header";
import Footer from "./layout/footer";
import Login from "./components/login";
import UserList from "./components/user";
import GeoTagsList from "./components/geotags";
import BusinessList from "./components/business";
import UserGeoTags from "./components/usergeotags";
import Contacts from "./components/contacts";
import UserList1 from "./components/user1";
import GeoTagView from "./components/geotags_view";
import Dashboard from "./components/Dashboard";
import HuntedList from "./components/hunted";
import Rewards from "./components/rewards";
import Levels from "./components/levels";
import AddLevel from "./components/level_add";
import ReferredUserView from "./components/referredUserView";
import DropGeotagForm from "./components/DropGeotagForm ";
import NotificationDetailsList from "./components/NotificationDetailsList";
import Questions from "./components/Questions";
import QuestionForm from "./components/QuestionForm";
import UserMonitoring from "./components/UserMonitoring";
// import Dashboard1 from "./components/Dashboard1";
const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(null); // Initially null to indicate loading state

  // Perform the authentication check when the app first mounts
  useEffect(() => {
    const isAuthenticated = checkUserAuthentication();
    setIsLoggedIn(isAuthenticated);
  }, []);

  // Function to check authentication
  const checkUserAuthentication = () => {
    const token = window.localStorage.getItem("email_address");
    return !!token; // Returns true if token exists, otherwise false
  };

  // If authentication state is still loading, render a loading state or nothing
  if (isLoggedIn === null) {
    return <div>Loading...</div>; // You can replace this with a spinner or something else
  }

  return (
    <BrowserRouter>
      <BodyClassManager isLoggedIn={isLoggedIn} />
      <Routes>
       
        <Route path="/login" element={!isLoggedIn ? <Login setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/list" />} />
        <Route path="/" element={isLoggedIn ? <Dashboard /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/users" element={isLoggedIn ? <UserList /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/users1" element={isLoggedIn ? <UserList1 /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/geotags" element={isLoggedIn ? <GeoTagsList /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/businesses" element={isLoggedIn ? <BusinessList /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/usergeotags" element={isLoggedIn ? <UserGeoTags /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/contacts" element={isLoggedIn ? <Contacts /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/geotag_view" element={isLoggedIn ? <GeoTagView /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/referrals" element={isLoggedIn ? <Contacts /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/dashboard" element={isLoggedIn ? <Dashboard /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        {/* <Route path="/dashboard1" element={isLoggedIn ? <Dashboard1 /> : <Login setIsLoggedIn={setIsLoggedIn} />} /> */}
        <Route path="/hunted" element={isLoggedIn ? <HuntedList /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/credits" element={isLoggedIn ? <Rewards /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/levels" element={isLoggedIn ? <Levels /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/level_add" element={isLoggedIn ? <AddLevel /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/level_edit" element={isLoggedIn ? <AddLevel /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/campaign" element={isLoggedIn ? <ReferredUserView /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/drop_geotag_form" element={isLoggedIn ? <DropGeotagForm /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/notification_details_list" element={isLoggedIn ? <NotificationDetailsList /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/questions" element={isLoggedIn ? <Questions /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/question_add" element={isLoggedIn ? <QuestionForm /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/user_monitor" element={isLoggedIn ? <UserMonitoring /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
      </Routes>
    </BrowserRouter>
  );
};

// Manage body class changes based on the authentication state
const BodyClassManager = ({ isLoggedIn }) => {
  const location = useLocation();

  useEffect(() => {
    if (!isLoggedIn) {
      document.body.classList.add('login-page');
      document.body.classList.remove('sidebar-mini');
    } else {
      document.body.classList.remove('login-page');
      document.body.classList.add('sidebar-mini');
    }
  }, [location.pathname, isLoggedIn]);

  return null;
};

export default App;
